import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import moment from "moment";
import "@ant-design/compatible/assets/index.css";
import { message, Button, Input, Select, Upload, DatePicker } from "antd";
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import fetchHandler from "@/fetch/fetchHandler";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { batchChangeTenceInfo, findTenceCompanyList, prefixFile } from "../../../fetch/fetchApi";

const FormItem = Form.Item;

// eslint-disable-next-line arrow-parens
@connect(state => state)
class SeeStubTenceInfoClass extends PureComponent {
  
  constructor(props) {
    super(props);
    this.state = {
      hidden:true,
      option: [],
      imageUrl:null,
      internationalization: this.props.intl.messages.seeStubTenceInfo,
    };
  }

  componentWillMount() {
    this.getFrameWork();
  }

    // 获取质保供应商
  getFrameWork() {
    this.setState({
      spinning: true,
      seconds: 11,
    });

    fetchHandler(findTenceCompanyList, {}).then((res) => {
      const option = res.data.map((item) => {
        let foo = {};
        foo = {
          label: item.companyName,
          value: item.id,
        };
        return foo;
      });

      this.setState({
        option: [...option],
        spinning: false,
      });
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({
          btnLoading: true,
        });
        var param = {};
        this.state.option.forEach((item) => {
          if (item.value == values.lockBrand) {
            param.companyName = item.label;
          }
        });
        if (this.props.isBatch && this.props.isBatch == 1) {
          var stubIds = [];
          var list = JSON.parse(this.props.stubIds);
          console.info(typeof list)
          list.forEach((item) => {
            stubIds.push(item.stubId)
          });
          param.stubIds = stubIds.join(',');
        } else {
          param.stubIds = this.props.stubId;
        }
        param.companyId = values.lockBrand;
        if (values.lockId) {
          param.tenceTime = values.lockId.toDate().getTime();
        }        
        fetchHandler(batchChangeTenceInfo, {
          ...param,
        }).then((res) => {
          if (this.props.setSelectedRowKeysNull) {
            this.props.setSelectedRowKeysNull();
          }
          if (res && res.code === "success") {
            message.success(this.state.internationalization.msg1); // '操作成功');
            if (this.props.onCancel) {
              this.props.onCancel();
            }
            if (this.props.refreshGrid) {
              this.props.refreshGrid();
            }
          }
          this.setState({
            btnLoading: false,
          });
        });
      }
    });
  };

  checkLength(rule, value, callback, item) {
    if ((value && value.length > item) || (value && value.length < 1)) {
      callback(
        `${this.state.internationalization.msg2 - 1}0${
          this.state.internationalization.msg2 - 2
        }${item}${this.state.internationalization.msg2 - 3}`,
      );
    }
    callback();
  }

  

  render() {
    const { getFieldDecorator } = this.props.form;
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 16, offset: 5 },
      },
    };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12, offset: 1 },
      },
    };
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label={'质保截止日期'}>
              {getFieldDecorator("lockId", {
                initialValue: (!this.props.tenceTime || this.props.tenceTime == null || this.props.tenceTime == '' || this.props.tenceTime == '--') ? null : moment(this.props.tenceTime),
              })(
                <DatePicker
                  placeholder={"年/月/日"}
                  format='YYYY/MM/DD'
                />
              )}
          </FormItem>


          <FormItem {...formItemLayout} label={'质保供应商'}>
            {getFieldDecorator("lockBrand", {
              rules: [
                {
                  required: true,
                  message: '请选择质保供应商', // "请选择要地锁品牌"
                },
              ],
              initialValue: (this.props.companyId == null || this.props.companyId == '--') ? '' : this.props.companyId,
            })(
              <Select
                  placeholder='请选择'
                  onSelect={(value, option) => {
                    
                  }}>
                  {this.state.option.map((item) => {
                    return (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    );
                  })}
                </Select>,
              )}
          </FormItem>


              
          <FormItem {...tailFormItemLayout} style={{ marginTop: 14 }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.state.btnDisabled}
              loading={this.state.btnLoading}>
              {this.state.internationalization.btn1}
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

const SeeStubTenceInfo = Form.create()(SeeStubTenceInfoClass);

export default injectIntl(SeeStubTenceInfo);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/seeStubTenceInfo.js